export default __webpack_public_path__ + "static/media/logotipo-home.d2f95074.svg";